import { useEffect } from "react";
import { useStores } from "../../../../stores/setup/use-store";

export function useLocationDataInitialization() {
	const {
		dataStores: {
			operationRuleStore,
			operationRuleLocationStore,
			operationRuleLocationInsightStore,
			locationStore,
		},
	} = useStores();

	useEffect(() => {
		if (locationStore.areas.length === 0) {
			locationStore.getAllLocationsAPI();
		}

		if (operationRuleStore.operationRules.length === 0) {
			operationRuleStore.getOperationRulesApi();
		} else if (
			operationRuleStore.operationRuleMainId > 0 &&
			operationRuleLocationStore.operationRuleLocations?.length === 0
		) {
			operationRuleLocationStore
				.getOperationRuleLocationsApi(operationRuleStore.operationRuleMainId)
				.then((locations) => {
					if (!locations?.length) {
						operationRuleLocationStore.setHasLocations(false);
						operationRuleLocationInsightStore.setHasInsights(false);
					} else {
						operationRuleLocationStore.setHasLocations(true);
					}
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
